import React from "react"
import Layout from "../components/Layout"

const contact = () => {
  return (
    <Layout>
      <main className="page">
        <section className="contact-page">
          <article className="contact-info">
            <h3>Want to get in touch?</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Error,
              eos vel et veritatis dolore, voluptas cum eaque deleniti tenetur
              saepe, obcaecati numquam. Iure dignissimos nesciunt ea dolorum
              consequatur earum molestias.
            </p>

            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
              adipisci aspernatur temporibus soluta quas iure corrupti
              laudantium recusandae delectus! Ducimus voluptate praesentium
              perferendis sapiente minima iste ut consectetur sint possimus.
            </p>
          </article>
          <article>
            <form className="form contact-form">
              <div className="form-row">
                <label htmlFor="name">Your name</label>
                <input type="text" name="name" id="name" />
              </div>
              <div className="form-row">
                <label htmlFor="email">Your email</label>
                <input type="text" name="email" id="email" />
              </div>
              <div className="form-row">
                <label htmlFor="message">Message</label>
                <textarea name="message" id="message" cols="30" rows="10" />
              </div>
              <button type="submit" className="btn block">
                submit
              </button>
            </form>
          </article>
        </section>
      </main>
    </Layout>
  )
}

export default contact
